// extracted by mini-css-extract-plugin
export default {"faqs":"Qtys_faqs__JZiCe"};